"use strict";

exports.VerificationHttpRepository = void 0;
var _VerificationFailedError = require("../data/errors/VerificationFailedError");
var _sdkTypes = require("../data/sdk-types");
var _HttpRepository = require("./HttpRepository");
class VerificationHttpRepository extends _HttpRepository.HttpRepository {
  async verifyPaymentAsync(wrappedPayload) {
    const res = await this.postAsync('verification/verifyPayment', wrappedPayload);
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError(res.content, {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_PAYMENT_LAMBDA,
        description: 'Unexpected error while trying to verify payment'
      });
    }
    return res.content;
  }
  async verifyTransactionAsync(payload, metadata, token, transactionId, targetNetwork, targetTokenAmountHex) {
    const res = await this.postAsync('verification/verify', {
      transactionId,
      verificationPayload: {
        ...payload,
        targetNetwork,
        targetTokenAmountHex
      },
      verificationMetadata: metadata
    }, {
      headers: {
        'x-presend-token': token
      }
    });
    if (res.status === 400) {
      throw new _VerificationFailedError.VerificationFailedError(res.content, {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: "Could not resolve ENS provider's name"
      });
    }
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError(res.content, {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_VERIFICATION_LAMBDA,
        description: 'Unexpected error while trying to verify transaction'
      });
    }
    return res.content;
  }
  async getSupportedExchangesAsync() {
    const res = await this.getAsync('supportedAssets/exchanges');
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get supported exchanges', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_SUPPORTED_ASSETS_LAMBDA,
        description: 'Unexpected error while trying to get supported exchanges'
      });
    }
    return res.content;
  }
  async getSupportedNetworksAsync() {
    const res = await this.getAsync('supportedAssets/networks');
    if (!res.success) {
      throw new _VerificationFailedError.VerificationFailedError('Failed to get supported networks', {
        component: _sdkTypes.ErrorContextComponent.VERIFICATION_SUPPORTED_ASSETS_LAMBDA,
        description: 'Unexpected error while trying to get supported networks'
      });
    }
    return res.content;
  }
}
exports.VerificationHttpRepository = VerificationHttpRepository;